



























import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import tagListDB from '@/dataBase/tagListDB';
import clone from '@/lib/clone';

@Component({
  components: {Icon}
})
export default class TagEdit extends Vue {
  tag!: myTag;
  iconName = '';
  id = 0;
  text = '';
  _iconName = '';
  _text = '';
  _id = 0;

  created() {
    this.currentTagList();
    this.id = this.tag.id;
    this.iconName = this.tag.iconName;
    this.text = this.tag.text;
    this._id = clone(this.id);
    this._iconName = clone(this.iconName);
    this._text = clone(this.text);
  }

  get tagList() {
    return this.$store.state.tagList as myTag[];
  }

  currentTagList() {
    const currentTag = this.tagList.filter(item => item.id.toString() === this.$route.params.tagid)[0];
    this.tag = currentTag;
    return tagListDB.filter(item => item.type === currentTag.type);
  }

  updateOneTag() {
    try {
      this.$store.commit('updateTag', {
        id: this.id,
        iconName: this.iconName,
        text: this.text,
        clonedTag: {id: this._id, iconName: this._iconName, text: this._text}
      });
      this.$router.back();
    } catch (error) {
      if (error.message === 'icon duplicated') {
        window.alert('标签图标重复，请重新选择！');
      } else if (error.message === 'text duplicated') {
        window.alert('标签名称重复，请重新输入！');
      } else if (error.message === 'text empty') {
        window.alert('标签名称不能为空，请重新输入！');
      } else if (error.message === 'text overtop') {
        window.alert('标签名称不能超过三个！');
      }
    }
  }

  selectedIcon(value: myTag) {
    this.iconName = value.iconName;
    this.id = value.id;
  }

}
